module.exports = __webpack_public_path__ + "img/chuneng2.f9eec57d.png";